<script lang="ts" setup>
import QuoteSuccessIcon from 'assets/icons/quote-success.svg'
import { useAnalyticalDataTracking } from '~/composables/analytics/useAnalyticalDataTracking'

const props = defineProps<{
  successId: number
  back?: boolean
}>()
const { t } = useLang()
const emit = defineEmits(['onBack'])
const viewRef = ref<HTMLDivElement | null>(null)

const onBack = () => emit('onBack')

onMounted(() => {
  useAnalyticalDataTracking().trackQuoteSubmit(props.successId)
  viewRef.value?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  })
})
</script>

<template>
  <div ref="viewRef" class="quote-success flex flex-col gap-4 w-full h-full px-4 lg:px-5">
    <img :src="QuoteSuccessIcon" height="170" class="my-5" />
    <div class="flex flex-col flex-1 gap-6">
      <h5 v-if="props.successId">{{ t('quotes.quote-success', { id: props.successId }) }}</h5>
      <p class="text-neutral3 dark:text-dmText3" v-html="t('quotes.quote-success-disclaimer')" />
    </div>
    <Button v-if="back" @click="onBack">{{ t('quotes.send-new-quote') }}</Button>
  </div>
</template>

<style lang="postcss">
.quote-success {
  img {
    height: 170px;
  }
  p > a {
    color: theme('colors.brand.primary') !important;
  }
}
</style>
